import React, { useState, useEffect } from 'react';
import '../styles.css';
import './Inicio.css';
import AgendaRed from '../Agenda/AgendaReduzida';

const spreadsheetID =  process.env.REACT_APP_SCHEDULE_SPREADSHEET_ID;
const url = `https://docs.google.com/spreadsheets/d/${spreadsheetID}/gviz/tq?tqx=out:json&tq=select%20*&headers=1`;

const Inicio = () => {

  const [tab, setTab] = useState(null); 
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(url);
        const text = await res.text();
        const data = JSON.parse(text.slice(47, -2));
        setTab(data); 
        setLoading(false); 
      } catch (err) {
        console.error('Erro ao buscar a planilha:', err);
        setLoading(false);
      }
    };
    fetchData();
  }, []); 

  return (
    <div className="main-page">
      <BigImageSection />
      <MainSection loading={loading} tab={tab} />
    </div>
  );
};


function BigImageSection() {

  return (
  <section className="big-image" style={{ alignItems: 'center' }}>
    <img src="../logomarrom.png" alt="logo" className="logo" />
  </section> )
}


function MainSection({ loading , tab }) {
  return (
    <section className="main-section">
      {loading ? <p>Carregando dados...</p> :
      <>
        <VideoSection />
        <AgendaSection tab={tab} />
      </>
      }
    </section>
  );
}

function VideoSection() {
  return (
    <div className="section-div">
      <h1 style={{ fontFamily: 'urban-stone' }}>
        <span>VIRÁ</span>
      </h1>
      <iframe
        className="main-iframe"
        src= {process.env.REACT_APP_YT_MAIN_VIDEO}
        title="Virá YT"
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </div>
  );
}

function AgendaSection({ tab }) {
  return (
    <div className="ag-div">
      <h1 style={{ fontFamily: 'urban-stone' }}>PRÓXIMO SHOW</h1>
      {tab ? <AgendaRed data={tab} /> : <p>Carregando...</p>}
    </div>
  );
}

export default Inicio;
